var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block"},[(_vm.value)?_c('ZTickSvg'):_c('ZTickEmptySvg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }